export default {
	"helpers.OnlyTheBeginningIsLeft": "距开始仅剩",
	"helpers.OnlyTheEndRemains": "距结束仅剩",
	"helpers.ThePurchaseQuantityCannotBe0": "购买数量不能为0",
	"helpers.prompt": "提示",
	"helpers.UntieTheBindingForTheTimeBeing": "暂不解绑",
	"helpers.UnbindTheAccount": "解绑账号",
	"helpers.SorryThePriceHasChanged": "抱歉，价格已发生变化!",
	"helpers.SorryTheVerificationFailed": "抱歉，验证未通过!",
	"helpers.YouHaveAnActivatedItem": "您存在已激活商品",
	"helpers.YouHaveSubscribedToTheItem": "您已订阅该商品",
	"helpers.PurchasesAreNotCurrentlyAvailableForThisItem": "该商品暂不支持购买"
}